import { ExhibitorDirectoryFilters, FilterClientType } from "@ac-expo/api-types";

const structureQueryKeys = {
  structures: "structures",
  commercials: ["commercials"] as const,
  meetings: ["meetings"] as const,
  all: ["structures"] as const,
  structure: () => [structureQueryKeys.structures, "mine"],
  request: (eventId?: string) => [
    structureQueryKeys.structures,
    "request",
    eventId,
  ],
  requestParticipations: () => [structureQueryKeys.structures, "request"],
  get: (id: string, eventId?: string) => [
    ...(eventId ? [structureQueryKeys.structures, eventId] : []),
    id,
  ],
  commercialBase: (structureId: string, eventId?: string) =>
    [structureQueryKeys.structures, "commercial", structureId, eventId ?? ""] as const,
  commercial: (structureId: string, eventId?: string, filters?: { searchText?: string }) => [
    ...structureQueryKeys.commercialBase(structureId, eventId),
    filters,
  ],
  getByCommercialId: (commercialId: string | undefined) => [
    "structures",
    commercialId,
  ],
  meetingByCommercialId: (commercialId: string | undefined) => [
    structureQueryKeys.meetings,
    commercialId,
  ],
  list: (filters: {
    eventId?: string;
    searchText?: string;
    isScanned?: boolean;
    isLiked?: boolean;
  }) => [structureQueryKeys.structures, filters],
  getEvents: (id: string) => ["events", id],
  visitors: (structureId: string, mode?: string) => [
    "visitors",
    structureId,
    mode,
  ],
  qrCode: (structureId: string, eventId: string) => [
    "qr-code",
    structureId,
    eventId,
  ],
  salesHistory: () => [...structureQueryKeys.all, "salesHistory"] as const,
  public: (id: string, eventId?: string) => ["public", id, eventId],
  exponentView: (id: string, eventId?: string) =>
    eventId
      ? (["exponent-view", id, eventId] as const)
      : (["exponent-view", id] as const),
  visitorsPaginated: (
    structureId: string,
    eventId?: string,
    filters?: {
      pagination?: { pageIndex: number; pageSize: number };
      sorting?: { id: string; desc: boolean }[];
      searchText?: string;
    }
  ) => ["visitors", "paginated", structureId, eventId, filters],
  directory: (filters?: ExhibitorDirectoryFilters) =>
    [...structureQueryKeys.all, "directory", filters] as const,
};

export const structureClientsQueryKeys = {
  all: ["structure-clients"] as const,
  byEventId: (
    eventId: string,
    filters?: FilterClientType & {
      pagination?: { pageIndex: number; pageSize: number };
      sorting?: { id: string; desc: boolean }[];
    }
  ) => [...structureClientsQueryKeys.all, "lists", eventId, filters] as const,
};

export default structureQueryKeys;
